// LIBRARIES
import { createAsyncThunk } from "@reduxjs/toolkit";

// MISC
import { REST } from "config/axiosConfig";
import { IInvoicesApiParams } from "models/interfaces";

export const getAllInvoices = createAsyncThunk(
  "payments/getAllPayments",
  async (data: IInvoicesApiParams) => {
    try {
      const response = await REST.post(
        `/payment/get-all-payments?${data.endDate && `endDate=${data.endDate}`
        }${data.page && `&page=${data.page}`}&size=7${
          data.startDate && `&startDate=${data.startDate}`
        }`,
        data.userFullName
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

